import script from "./WebsiteOptOutView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WebsiteOptOutView.vue?vue&type=script&lang=ts&setup=true"

import "./WebsiteOptOutView.vue?vue&type=style&index=0&id=3b3bedaa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b3bedaa"]])

export default __exports__